import { getWorkflow as getWorkflowApi } from '@/utils/maaran'
import { useQuery } from '@tanstack/react-query'

export default function useWorkflow(workflowId) {
    const {data, isLoading, isError, isFetching} = useQuery({
        queryKey: ['workflow', workflowId],
        queryFn: () => getWorkflowApi(workflowId),
        enabled: !!workflowId,
        cacheTime: 100000,
        staleTime: 100000,
    });

    return {data, isLoading, isError, isFetching};
}
